<template>
  <b-container class="fill d-flex justify-content-center">
    <b-row class="w-100">
      <b-col class="p-3 mx-lg-5 mb-5">
        <slot />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "PageContent"
}
</script>

<style lang="scss">
  @import '@design';
  .fill {
    flex: 1;
  }

  p {
    line-height: typography-line-height(2);
  }
</style>
